import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";

const HorizontalCTABackgroundColor = ({ data }) => {
    const { additionalConfiguration, backgroundColor, backgroundImage, cardItem, customId } = data;
    const { cta, title } = cardItem || {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-7.5");
    const { sectionColorMapping } = getColorClassName(backgroundColor);
    return (
        <section className={`${sectionSpacingClassName}`} id={customId}>
            <div className="container xl:max-w-[1170px]">
                <div
                    className={`${sectionColorMapping.bgColor ||
                        "bg-ocean"} row p-7.5 lg:px-11.25 lg:py-15 items-center bg-no-repeat rounded bg-horizontal-cta bg-horizontal-cta-bg`}
                    style={backgroundImage ? { backgroundImage: `url(${backgroundImage?.[0]?.secure_url})` } : null}
                >
                    <div className="col-12 md:col-6 lg:col-8">
                        {title && (
                            <h2
                                className={`${sectionColorMapping.primaryTextColor ||
                                    "text-white"} title-3 text-center md:text-left`}
                            >
                                {title}
                            </h2>
                        )}
                    </div>
                    <div className="col">
                        <div className="flex gap-3.75 flex-wrap justify-center md:justify-end mt-2.5 md:mt-0">
                            {cta?.map((button) => (
                                <Cta key={button.id} data={button} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HorizontalCTABackgroundColor;
